/* eslint-disable react/no-unused-prop-types */
import Backbone from 'backbone';
import ReactDOM from 'react-dom';
import React from 'react';
import { ChoiceGroup, TextField, Stack, DefaultButton, PrimaryButton } from '@fluentui/react';
import decimalNumber from '@bingads-webui-component-legacy/humanize/decimal';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { getInlineEditorViewStyles } from './style';

const InlineEditor = (props) => {
  const [selectedKey, setSelectedKey] = React.useState(props.isUsingInheritedValue ? 'inherited' : 'customed');
  const [customedValue, setCustomedValue] =
    React.useState((props.dataType === 'Percent' && !_.isEmpty(props.customedValue)) ? props.customedValue.replace('%', '') : props.customedValue);

  const onChangeOption = (ev, option) => {
    setSelectedKey(option.key);
  };
  const styles = getInlineEditorViewStyles();
  const inheritedValueName = props.i18n.getString(`RSAAdCustomizer_${props.inheritedValueLevel}_Value`);
  const options = [
    {
      key: 'inherited',
      labelId: 'inherited',
      text: props.i18n.getString('RSAAdCustomizer_Use_Inherited_Value'),
      onRenderField: (optionPops, render) => (
        <div>
          {render(optionPops)}
          <br />
          <div className="inherited-value">
            {
              _.isEmpty(props.inheritedValue) ? '-' : `${inheritedValueName}: ${props.inheritedValue}`
            }
          </div>
        </div>
      ),
    },
    {
      key: 'customed',
      labelId: 'customed',
      text: props.i18n.getString('RSAAdCustomizer_Use_Custom_Value'),
    },
  ];

  return (
    <div className="attribute-inilne-editor">
      <ChoiceGroup
        styles={styles.choiceGroup}
        selectedKey={selectedKey}
        options={options}
        onChange={onChangeOption}
      />
      {
        selectedKey === 'customed' ?
        (
          <React.Fragment>
            <span>{props.attributeName} ({props.dataType})</span>
            <Stack horizontal tokens={{ childrenGap: 3 }}>
              <TextField
                styles={styles.textField}
                className="customed-value-input"
                ariaLabel={`${props.attributeName} (${props.dataType})`}
                value={customedValue}
                onChange={(event, value) => setCustomedValue(value, selectedKey)}
              />
              {
                props.dataType === 'Percent' ?
                  <Stack.Item align="center"><span>%</span></Stack.Item> : null
              }
            </Stack>
          </React.Fragment>
         ) : null
      }

      <Stack horizontal tokens={{ childrenGap: 8, padding: '16px 0 0 0' }}>
        <PrimaryButton text={props.i18n.getString('Save')} onClick={() => props.save(customedValue, selectedKey, props.dataType)} />
        <DefaultButton text={props.i18n.getString('Cancel')} onClick={() => props.cancel()} />
      </Stack>
    </div>
  );
};

InlineEditor.propTypes = {
  isUsingInheritedValue: PropTypes.bool.isRequired,
  inheritedValue: (PropTypes.number || PropTypes.string).isRequired,
  inheritedValueLevel: PropTypes.string.isRequired,
  attributeName: PropTypes.string.isRequired,
  dataType: PropTypes.string.isRequired,
  customedValue: (PropTypes.number || PropTypes.string).isRequired,
  cancel: PropTypes.func.isRequired,
  save: PropTypes.func.isRequired,
  i18n: PropTypes.func.isRequired,
};

export class AdCustomizerAttributeInlineEditor extends Backbone.View {
  initialize({
    isUsingInheritedValue,
    inheritedValue,
    inheritedValueLevel,
    value,
    valueLevel,
    currentLevel,
    dataType,
    attributeName,
    i18n = { getString: x => x },
  }) {
    this.i18n = i18n;
    this.isUsingInheritedValue = isUsingInheritedValue;
    this.inheritedValue = this.isUsingInheritedValue ? value : inheritedValue;
    this.inheritedValueLevel = this.isUsingInheritedValue ? valueLevel : inheritedValueLevel;
    this.value = value;
    this.valueLevel = valueLevel;
    this.currentLevel = currentLevel;
    this.dataType = dataType;
    this.attributeName = attributeName;
  }

  render() {
    ReactDOM.render(
      <InlineEditor
        isUsingInheritedValue={this.isUsingInheritedValue}
        inheritedValue={this.inheritedValue}
        inheritedValueLevel={this.inheritedValueLevel}
        customedValue={this.isUsingInheritedValue ? '' : this.value}
        attributeName={this.attributeName}
        dataType={this.dataType}
        cancel={() => this.cancel()}
        save={(value, selectedKey, dataType) => this.save(value, selectedKey, dataType)}
        i18n={this.i18n}
      />,
      this.el
    );
    return this;
  }

  save(customedValue, selectedKey, dataType) {
    if (selectedKey === 'inherited' && !this.isUsingInheritedValue) {
      this.trigger('save', { value: 'delete_value' });
      return;
    }
    if (selectedKey === 'customed' && !_.isEmpty(customedValue) &&
        (this.value !== customedValue || this.currentLevel !== this.valueLevel)) {
      const formattedValue = dataType === 'String' || dataType === 'Price' ? customedValue : decimalNumber.fromLocalToFloat(customedValue) || customedValue;
      this.trigger('save', { value: formattedValue });
      return;
    }
    this.trigger('close');
  }

  cancel() {
    this.trigger('close');
  }
}
